import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';

import List from './list/List';

const buildDefaultSelection = (caregiverRn) => {
  return {
    order: {orderBy: 'updatedAt', orderDirc: 'DESC'},
    filter: {
      participantRn: {
        filterData: {key: 'participantRn'},
        optionSelected: caregiverRn,
      },
    },
  };
};

const Case = (props) => {
  const caregiverRn = props.caregiverRn;

  const [reload, setReload] = React.useState(0);
  const selection = React.useMemo(() => buildDefaultSelection(caregiverRn), [caregiverRn]);

  return (
    <Grid container spacing={1} p={2}>
      <Grid item xs={12}>
        <List
          selection={selection}
          reload={reload}
          setReload={setReload}
        />
      </Grid>
    </Grid>
  );
};

Case.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Case));
